import { useGameStore } from '../../store';

export default function DisclaimerModal() {
  const show    = useGameStore((s) => s.showDisclaimerModal);
  const confirm = useGameStore((s) => s.confirmDisclaimer);

  if (!show) return null;

  return (
    <div className="modal-backdrop center" style={{ display: 'flex' }}>
      <div className="modal-sheet mid">
        <div className="modal-title">⚠️ 이용 안내</div>
        <div className="modal-body">
          본 게임은 가상의 시뮬레이션이며, 실제 투자와 무관합니다.<br /><br />
          게임 내 <strong>냥(兩)</strong>은 어떠한 현금 가치도 없으며, 환전·이전이 불가능합니다.<br /><br />
          종목명(청자방, 비단상단, 화약방)은 모두 가상이며 실존 종목과 무관합니다.
        </div>
        <button className="modal-btn" onClick={confirm}>확인하고 시작하기</button>
      </div>
    </div>
  );
}
